export const sortWithBooleanValues = (a, b) => {
  if (a === true && b === false) return -1;
  if (a === false && b === true) return 1;
  return 0;
};
